import React, {Component} from "react"
import withStyles from "@mui/styles/withStyles";
import {withRouter} from "react-router-dom";
import LinearProgress from "@mui/material/LinearProgress";
import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Box,
    Button,
    List,
    ListItem,
    ListItemText,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow
} from "@mui/material";
import Typography from "@mui/material/Typography";
import {get_order} from "../actions/orders";
import Grid from "@mui/material/Grid";
import {clamp} from "../utilities/clamp";
import {formatDateTime} from "../utilities/date";
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import GetAppIcon from "@mui/icons-material/GetApp";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const styles = {
    root: {
        padding: 10
    },
    paper: {
        margin: 10,
        padding: 15
    }
};


class Order extends Component {

    constructor(props) {
        super(props);
        this.state = {
            order: null,
            errors: {},
        }
    }

    componentDidMount() {
        this.getOrder(parseInt(this.props.match.params.order_id));
    }

    getOrder(id) {
        get_order(id).then(r => {
            this.setState({
                ...this.state,
                order: r.data
            });
        });
    }

    formatPrice(price) {
        //price = Math.round(price * 100) / 100;
        return price.toFixed(2);
    }


    render() {
        if (this.state.order === null) {
            return <LinearProgress/>
        }
        const {classes} = this.props;
        const selected_plan_price = this.state.order.tier === "great" ? 99.95 : 79.95;
        return (<Box className={classes.root}>
            <Button
                className={classes.button}
                startIcon={<ChevronLeftIcon/>}
                onClick={() => {
                    this.props.history.push("/orders");
                }}
            >
                Back
            </Button>
            <Typography variant={"h5"} gutterBottom={true}>Order {this.state.order.id}
                <Button
                    variant="contained"
                    color="primary"
                    size="small"
                    className={classes.button}
                    startIcon={<GetAppIcon/>}
                    href={this.state.order.download}
                    target={"_blank"}
                    style={{marginLeft: 15}}
                >
                    PDF
                </Button>
                <Button
                    variant="contained"
                    color="primary"
                    size="small"
                    className={classes.button}
                    startIcon={<GetAppIcon/>}
                    href={this.state.order.download + "&type=xml"}
                    target={"_blank"}
                    style={{marginLeft: 15}}
                >
                    XML
                </Button>
            </Typography>
            <Grid container>
                <Grid item xs={12} md={6}>
                    <Paper className={classes.paper}>
                        <Typography variant={"h5"} gutterBottom={true}>Customer details</Typography>
                        <Typography>
                            {this.state.order.first_name} {this.state.order.last_name}<br/>
                            {this.state.order.street}<br/>
                            {this.state.order.postal_code} {this.state.order.city}<br/>
                            {this.state.order.country_code}<br/>
                            {this.state.order.email}<br/>
                            {this.state.order.phone_number}
                        </Typography>
                    </Paper>
                    <Paper className={classes.paper}>
                        <Typography variant={"h5"} gutterBottom={true}>Payments</Typography>
                        {this.state.order.payments.map((payment, index) =>
                            <Accordion key={"AC" + index}>
                                <AccordionSummary expandIcon={<ExpandMoreIcon/>}>
                                    <Typography>{formatDateTime(new Date(payment.created_at))} - {payment.price} EUR
                                        ({payment.current_state})</Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <List>
                                        {payment.states.map((state, i) =>
                                            <ListItem key={"LI" + index + "-" + i}>
                                                <ListItemText primary={state.state}
                                                              secondary={formatDateTime(new Date(state.created_at))}/>
                                            </ListItem>
                                        )}
                                    </List>
                                </AccordionDetails>
                            </Accordion>
                        )}
                    </Paper>
                </Grid>
                <Grid item xs={12} md={6}>
                    <Paper className={classes.paper}>
                        <Typography variant="h5" gutterBottom={true}>Order</Typography>
                        <TableContainer>
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell align="left">Item</TableCell>
                                        <TableCell align="center">Duration</TableCell>
                                        <TableCell align="center">Price</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    <TableRow>
                                        <TableCell align="left">Premium</TableCell>
                                        <TableCell
                                            align="center">{this.state.order.days === 365 ? "Year" : "Month"}</TableCell>
                                        <TableCell align="center">
                                            {
                                            this.state.order.coupon_type === null ?
                                                selected_plan_price
                                                :
                                                (
                                                    this.state.order.coupon_type === "fixed"
                                                        ?
                                                        this.formatPrice(selected_plan_price - clamp(this.state.order.coupon_value, 0, selected_plan_price))
                                                        :
                                                        this.formatPrice(selected_plan_price * (1 - (clamp(this.state.order.coupon_value, 0, 100) / 100)))
                                                )
                                            } EUR
                                        </TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </TableContainer>
                        <Typography variant="h5" gutterBottom={true}>Coupon</Typography>
                        {this.state.order.coupon_value &&
                        <Typography>
                            {this.state.order.coupon_type === "fixed" ? <>
                                -{this.state.order.coupon_value} €
                            </> : <>
                                -{this.state.order.coupon_value}%
                            </>}
                        </Typography>}
                        {this.state.order.coupon_value === null &&
                        <Typography>
                            None
                        </Typography>}
                    </Paper>
                </Grid>
            </Grid>
        </Box>)
    }
}

export default withRouter(withStyles(styles)(Order));
